import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

// const GridInputRow = (props) => (
const GridInputRow = React.forwardRef((props, ref) => (
  <Grid
    item
    container
    spacing={3}
    direction="row"
    alignItems="flex-end"
    ref={ref}
  >
    {props.children}
  </Grid>
));

GridInputRow.propTypes = {
  children: PropTypes.node,
};

export default GridInputRow;
